import { useState } from 'react';
import { FiTruck } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { DirectoryFormModal } from '../Directory/DirectoryFormModal';
import { FormField, inputClassName } from '../ui/FormField';

const SupplierForm = ({ showSupplierForm, onClose, onSubmit, supplier, setSupplier, type }) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const update = (field) => (event) => setSupplier((current) => ({ ...current, [field]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try { await onSubmit(event); } finally { setSubmitting(false); }
  };

  return (
    <DirectoryFormModal
      open={showSupplierForm}
      onClose={onClose}
      onSubmit={submit}
      title={type === 'Add' ? t('Add New Supplier') : t('Edit supplier')}
      description={t('Keep supplier contact information current.')}
      icon={FiTruck}
      submitLabel={submitting ? t('Processing...') : type === 'Add' ? t('Add') : t('Edit')}
      cancelLabel={t('Cancel')}
      closeLabel={t('Close')}
      submitting={submitting}
      width={760}
    >
      <div className='grid gap-4 sm:grid-cols-2'>
        <FormField label={t('Name')} required><input autoFocus type='text' className={inputClassName} value={supplier.name || ''} onChange={update('name')} required /></FormField>
        <FormField label={t('Email')} required><input type='email' autoComplete='email' className={inputClassName} value={supplier.email || ''} onChange={update('email')} required /></FormField>
        <FormField label={t('Phone Number')} required><input type='tel' autoComplete='tel' className={inputClassName} value={supplier.phoneNumber || ''} onChange={update('phoneNumber')} required /></FormField>
        <FormField label={t('Home Address')} required><input type='text' autoComplete='street-address' className={inputClassName} value={supplier.homeAddress || ''} onChange={update('homeAddress')} required /></FormField>
      </div>
    </DirectoryFormModal>
  );
};

export default SupplierForm;
